import React, { useEffect, useState } from "react";

import { notification } from "../../../services/helpers";
import { useAuthentication } from "../../hooks";
import { getPlansRequest } from "../../requests";

import { useActions } from "../../provider";
import * as Styles from "./styles";

export function ChoosePlan() {
  const [plansList, setPlansList] = useState(
    JSON.parse(sessionStorage.getItem("plansList" || "[]")) || []
  );
  const { stepManager, setActionsState, actionsState, setIsLoading, config } =
    useActions();
  const { authToken } = useAuthentication({ setIsLoading });

  const handleSelectPlan = (plan) => {
    setActionsState({
      plan: {
        ...plan,
        enable_program: true,
      },
    });
    stepManager.next();
  };

  useEffect(() => {
    async function handleLoadPlans() {
      try {
        setIsLoading(true);
        if (plansList.length) return;

        const response = await getPlansRequest({
          msisdn: actionsState.msisdn,
          authToken,
          url: config.GET_VALUES_ENDPOINT
        });
        if (response.data.valueList.length > 0) {
          setPlansList(response.data.valueList);
          sessionStorage.setItem(
            "plansList",
            JSON.stringify(response.data.valueList)
          );
        } else {
          setIsLoading(false);
          await notification("error", "Não foi possível carregar os planos.");
          stepManager.previous();
        }
      } catch (error) {
        console.log({ error });
        notification(
          "error",
          error.response?.data?.msg || "Não foi possível carregar os planos."
        );
      } finally {
        setIsLoading(false);
      }
    }

    handleLoadPlans();
  }, []);

  return (
    <Styles.ContentPlans>
      <h1>Selecione o valor da recarga</h1>
      <Styles.ContainerPlans>
        {plansList?.map((plan) => (
          <Styles.PlanCard
            key={plan.value}
            onClick={() => handleSelectPlan(plan)}
          >
            <img src={plan.note} alt={`Plano de ${plan.value}`} />
          </Styles.PlanCard>
        ))}
      </Styles.ContainerPlans>
    </Styles.ContentPlans>
  );
}
